import { render, staticRenderFns } from "./vertifyMoblie.vue?vue&type=template&id=a6bd300c&scoped=true&"
import script from "./vertifyMoblie.vue?vue&type=script&lang=js&"
export * from "./vertifyMoblie.vue?vue&type=script&lang=js&"
import style0 from "./vertifyMoblie.vue?vue&type=style&index=0&id=a6bd300c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd300c",
  null
  
)

export default component.exports